import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { connect } from 'react-redux';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import BeneficaryMember from '../../Application/BeneficaryMember';

const BeneficiaryInformation = (props) => {
    const { applicationDetail, beneDetail, editMode, schoolList, errorMessage } = props;

    /* NOTE:
     * Show "Relationship to Beneficiary" for household members (incl. Main Applicant)
     * Show "Relationship to Applicant" for beneficiary
     */

    let relationToShow = 'Beneficiary';
    if (beneDetail.RecordType.Name === 'Beneficiary') {
        relationToShow = 'Applicant';
    }

    const beneficiaryRelationshipList = [
        'Ward', 'Son', 'Daughter', 'Step son', 'Step daughter', 'Grandchild', 'Others'
    ];
    const householdMemberRelationshipList = [
        'Father', 'Mother', 'Sister', 'Brother', 'Step Sister', 'Step Brother', 'Grandparent', 'Uncle',
        'Aunt', 'Others', 'Step Mother', 'Step Father'
    ];

    const relationPickList = props.getPicklist('Person__c', `Relationship_to_${relationToShow}__c`);

    // const beneRelPickList = relationPickList.filter(relation => beneficiaryRelationshipList.includes(relation.props.value));
    // const houRelPickList = relationPickList.filter(relation => householdMemberRelationshipList.includes(relation.props.value));

    const beneRelPickList = relationPickList
    const houRelPickList = relationPickList
    /* let grandparentType = '';

    if (beneDetail[`Relationship_to_${relationToShow}__c`] === 'Grandparent') {
        if (beneDetail.Gender__c === 'Male') {
            grandparentType = 'Grandfather';
        } else {
            grandparentType = 'Grandmother';
        }
    } */

    return (
        <div className="x_content" style={{ display: 'block' }}>
            <div className="col-sm-6">
                <div className="form-group">
                    <label>
                        Full Name
                    </label>
                    <input
                        type="text"
                        className={`form-control scalable ${errorMessage.Full_Name__c ? 'need-fix' : ''}`}
                        value={beneDetail ? beneDetail.Full_Name__c || '' : ''}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged('Full_Name__c', e.target.value)}
                    />
                    <p className="error-message">{errorMessage.Full_Name__c}</p>

                </div>
                <div className="form-group">
                    <label>ID Type</label>
                    <select
                        className="form-control"
                        value={beneDetail ? beneDetail.ID_Type__c : ''}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged('ID_Type__c', e.target.value)}
                    >
                        {props.getPicklist('Person__c', 'ID_Type__c')}
                    </select>
                </div>
                <div className="form-group">
                    <label>ID Number</label>
                     <input
                        name="ID_Number__c"
                        id="ID_Number__c"
                        type="text"
                        className={`form-control ${errorMessage.ID_Number__c ? 'need-fix' : ''}`}
                        value={beneDetail ? beneDetail.ID_Number__c : ''}
                        maxLength={beneDetail.ID_Type__c === 'Others' ? 32 : 9}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged('ID_Number__c', e.target.value)}
                        placeholder="NRIC e.g. S9268776G"
                    />
                    <p className="error-message">{errorMessage.ID_Number__c}</p>
                </div>
                {/* <div className="form-group">
                    <label>Gender</label>
                    <select
                        className="form-control"
                        value={beneDetail ? beneDetail.Gender__c : ''}
                        onChange={e => props.onFormChanged('Gender__c', e.target.value)}
                        disabled={!editMode}
                    >
                        <option value="" />
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div> */}
                {beneDetail.RecordType.Name === 'Beneficiary' ?
                    <div className="form-group">
                        <label>Current School</label>
                        <ReactSelect
                            options={schoolList}
                            isDisabled={!editMode}
                            onChange={(val) => {
                                props.onFormChanged('multiStateChangeBene', {
                                    Current_School__r: val.value,
                                    Applying_to__r: val.value,
                                    Current_Level__c: ''
                                });
                            }}
                            value={beneDetail.Current_School__r ? { value: beneDetail.Current_School__r.Id, label: beneDetail.Current_School__r.Name } : {}}
                        />
                    </div> : ''
                }
                <div className="form-group">
                    <label>Nationality</label>
                    <select
                        className="form-control"
                        value={beneDetail ? beneDetail.Nationality__c : ''}
                        onChange={e => props.onFormChanged('Nationality__c', e.target.value)}
                        disabled={!editMode}
                    >
                        {props.getPicklist('Person__c', 'Nationality__c')}
                    </select>
                </div>
                <div className="form-group">
                    <label>Other Nationality</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.Other_Nationality__c || '' : ''}
                        disabled={!editMode || beneDetail.Nationality__c !== 'Others'}
                        onChange={e => props.onFormChanged('Other_Nationality__c', e.target.value)}
                    />
                </div>
                {/* Employment Status */}
                {/* {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Employment Status</label>
                        <select
                            className="form-control"
                            value={beneDetail ? beneDetail.Employment_Status__c : ''}
                            disabled={!editMode}
                            onChange={e => props.onFormChanged('Employment_Status__c', e.target.value)}
                        >
                            {props.getPicklist('Person__c', 'Employment_Status__c')}
                        </select>
                    </div> : ''
                } */}
                {/* Occupation */}
                {/* {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Occupation</label>
                        <input
                            type="text"
                            className="form-control"
                            value={beneDetail ? beneDetail.Occupation__c || '' : ''}
                            disabled={!(editMode && beneDetail.Employment_Status__c !== 'Unemployed')}
                            onChange={e => props.onFormChanged('Occupation__c', e.target.value)}
                        />
                    </div> : ''
                } */}
                {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Marital Status</label>
                        <select
                            className="form-control"
                            value={beneDetail ? beneDetail.Marital_Status__c : ''}
                            disabled={!editMode}
                            onChange={e => props.onFormChanged('Marital_Status__c', e.target.value)}
                        >
                            {props.getPicklist('Person__c', 'Marital_Status__c')}
                        </select>
                    </div> : ''}
                {beneDetail.Main_Applicant__c ?
                    <div className="form-group">
                        <label>Other Source of Income</label>
                        <select
                            className="form-control"
                            value={applicationDetail ? applicationDetail.Other_Source_of_Income__c : ''}
                            disabled={!editMode}
                            onChange={e => props.onFormChanged('Other_Source_of_Income__c', e.target.value)}
                        >
                            {props.getPicklist('Application__c', 'Other_Source_of_Income__c')}
                        </select>
                    </div> : ''
                }
                {beneDetail.Main_Applicant__c ?
                    <div className="form-group">
                        <label>Other Source of Income Amount</label>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            className="form-control"
                            value={applicationDetail ? applicationDetail.Other_Source_of_Income_Amount__c || '' : ''}
                            disabled={!(editMode && applicationDetail.Other_Source_of_Income__c !== 'None')}
                            onChange={e => props.onFormChanged('Other_Source_of_Income_Amount__c', e.target.value)}
                        />
                    </div> : ''
                }
                {/* <div className="form-group">
                    <label>Incomplete Document</label>
                    <input
                        type="checkbox"
                        style={{ width: 20, height: 20 }}
                        checked={beneDetail ? beneDetail.Incomplete_Document__c : null}
                        onChange={e => props.onFormChanged('Incomplete_Document__c', e.target.checked)}
                        disabled={!editMode}
                    />
                </div> */}
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Relationship to {relationToShow}</label>
                    {beneDetail &&
                        <select
                        className="form-control"
                        value={beneDetail[`Relationship_to_${relationToShow}__c`]}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged(`Relationship_to_${relationToShow}__c`, e.target.value)}
                    >
                        {beneDetail.RecordType.Name === 'Beneficiary' ? beneRelPickList : houRelPickList}
                    </select>}
                </div>
                <div className="form-group">
                    <label>Other Relationship</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail.RecordType.Name === 'Beneficiary' ? beneDetail.Relationship_to_Applicant_Other__c : beneDetail.Relationship_to_Beneficiary_Other__c}
                        disabled={!editMode || beneDetail[`Relationship_to_${relationToShow}__c`] !== 'Others'}
                        onChange={e => props.onFormChanged(`Relationship_to_${relationToShow}_Other__c`, e.target.value)}
                        maxLength="255"
                    />
                </div>
                <div className="form-group">
                    <label>Application Date</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.Application_Date__c || '' : ''}
                        disabled
                    />
                </div>
                <div className="form-group">
                    <label>Date of Birth</label>
                    <DatePicker
                        name={`Date_of_Birth__c`}
                        dateFormat="YYYY-MM-DD"
                        className={`form-control ${errorMessage.Date_of_Birth__c ? 'need-fix' : ''} fullwd`}
                        selected={beneDetail.Date_of_Birth__c ? moment(beneDetail.Date_of_Birth__c) : null}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={moment()}
                        disabled={!editMode}
                        onChange={val => props.onFormChanged('Date_of_Birth__c', val)}
                    />
                    <p className="error-message">{errorMessage.Date_of_Birth__c}</p>
                    
                </div>
                <div className="form-group">
                    <label>Age at Application</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.Age_at_Application__c || '' : ''}
                        disabled
                    />
                </div>
                {/* <div className="form-group">
                    <label>Race</label>
                    <select
                        className="form-control"
                        value={beneDetail ? beneDetail.Race__c : ''}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged('Race__c', e.target.value)}
                    >
                        {props.getPicklist('Person__c', 'Race__c')}
                    </select>
                </div>
                <div className="form-group">
                    <label>Other Race</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.Other_Race__c || '' : ''}
                        disabled={!editMode || beneDetail.Race__c !== 'Others'}
                        onChange={e => props.onFormChanged('Other_Race__c', e.target.value)}
                    />
                </div> */}
                
                {/* Other Marital Status */}
                {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Other Marital Status</label>
                        <input
                            type="text"
                            className="form-control"
                            value={beneDetail ? beneDetail.Other_Marital_Status__c || '' : ''}
                            disabled={!editMode || beneDetail.Marital_Status__c !== 'Others'}
                            onChange={e => props.onFormChanged('Other_Marital_Status__c', e.target.value)}
                        />
                    </div> : ''
                }
                {/*  Monthly Gross Income */}
                {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Monthly Gross Income</label>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            className="form-control"
                            value={beneDetail ? beneDetail.Monthly_Gross_Income__c || '' : ''}
                            disabled={!(editMode && beneDetail.Employment_Status__c !== 'Unemployed')}
                            onChange={e => props.onFormChanged('Monthly_Gross_Income__c', e.target.value)}
                        />
                    </div> : ''
                }
                {/* Company */}
                {/* {beneDetail.RecordType.Name === 'Household Member' ?
                    <div className="form-group">
                        <label>Company</label>
                        <input
                            type="text"
                            className="form-control"
                            value={beneDetail ? beneDetail.Company__c || '' : ''}
                            disabled={!(editMode && beneDetail.Employment_Status__c !== 'Unemployed')}
                            onChange={e => props.onFormChanged('Company__c', e.target.value)}
                        />
                    </div> : ''
                } */}
            </div>
        </div>
    );
};

BeneficiaryInformation.propTypes = {
    beneDetail: PropTypes.object.isRequired,
    editMode: PropTypes.bool,
    getPicklist: PropTypes.func.isRequired,
    onFormChanged: PropTypes.func.isRequired,
};

BeneficiaryInformation.defaultProps = {
    editMode: false,
};

const mapStateToProps = state => ({
    relationshipList: state.objectInfo.Person__c.filter(obj => obj.name === 'Relationship_to_Applicant__c').length ? state.objectInfo.Person__c.filter(obj => obj.name === 'Relationship_to_Applicant__c')[0].picklistValues : [],
});

export default connect(mapStateToProps)(BeneficiaryInformation);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/components/BeneficiaryInformation.js
// module id = 869
// module chunks = 0